export const FETCH_ITEM = 'campaignCreatePage/FETCH_ITEM';

export const SUBMIT_REVIEW = 'campaignCreatePage/SUBMIT_REVIEW';
